import PptxGenJS from "pptxgenjs"
import { flatJoin, splitTextInRect } from 'shared/util'
import { KojinResult } from 'interface/kojin'

import { slideFrom } from '../util/slideFrom'
import { KojinPptxComponentsProps } from '../types'

import { continueText } from './continueText'

const authorsIndexLayout = {
  header: {
    height: 0.6
  },
  column: {
    number: 0.6,
    //identifier,
    approach: 4.2,
    confidenceScore: 1
  },
  margin: {
    cx: 0.1,
    cy: 0.05
  }
}
const colors = {
  border: 'ffffff',
  header: 'bcbdc0',
  even: 'e7e8e8',
  odd: 'f4f4f4',
  star: {
    active: 'FFC000',
    inActive: 'D0CECE'
  }
}
type authorsIndexHeaderProps = KojinPptxComponentsProps & {
  title: string
  pageNo: number
}
const authorsIndexHeader = ({
  title,
  pageNo,
  ...other
}: authorsIndexHeaderProps) => {
  const { pptx, slide, layout } = other
  const top = 0
  const width = slideFrom(layout, 'width', 0, false)
  const height = authorsIndexLayout.header.height

  slide.addText([{
    text: `${title}／医師一覧 - ${pageNo}`,
    options: {
      ...layout.textOption,
      fontSize: layout.baseFont.fontSize * 2.5,
      breakLine: true
    }
  }], {
    x: 0, y: top, w: width, h: height,
    margin: [20, 20, 5, 5], 
    align: 'left', valign: 'bottom',
    breakLine: true, wrap: false, autoFit: true
  })

  slide.addShape(pptx.ShapeType.line, {
    x: 0, y: height, w: width, h: 0,
    line: { color: "ad0026", width: 3 }
  })
}

type authorsIndexProps = KojinPptxComponentsProps & {
  title: string
  kojinList: KojinResult[]
  scale?: number
}
type authorsIndexReturnValue = {
	slide: PptxGenJS.Slide
  bottom: number
}
export const authorsIndex = ({
  title,
  kojinList,
  scale: nullableScale,
  ...other
}: authorsIndexProps): authorsIndexReturnValue => {
  const { pptx, layout, slide } = other
  const lineHeight = 0.017 * layout.baseFont.fontSize
  const scale = nullableScale ?? 1

  let pageNo = 0
  authorsIndexHeader({ ...other, title, pageNo: ++pageNo })
  const tableTop = authorsIndexLayout.header.height + layout.margin

  const header: PptxGenJS.TableRow[] = [[{
    text: 'No',
    options: {
      ...layout.cellOption,
      fontSize: (layout.cellOption.fontSize ?? 0) * scale,
      fill: { color: colors.header },
      align: 'center'
    }
  }, {
    text: '医師名',
    options: {
      ...layout.cellOption,
      fontSize: (layout.cellOption.fontSize ?? 0) * scale,
      fill: { color: colors.header }
    }
  }, /*{
    text: '依頼内容',
    options: {
      ...layout.cellOption,
      fontSize: (layout.cellOption.fontSize ?? 0) * scale,
      fill: { color: colors.header }
    }
  }, {
    text: '推奨度',
    options: {
      ...layout.cellOption,
      fontSize: (layout.cellOption.fontSize ?? 0) * scale,
      fill: { color: colors.header },
      align: 'center'
    }
  }*/]]
  const bottom = slideFrom(layout, 'bottom', 0)
  const identifierWidth = slideFrom(layout, 'width', 
    (authorsIndexLayout.column.number * scale)/* + 
    (authorsIndexLayout.column.approach * scale) + 
    (authorsIndexLayout.column.confidenceScore * scale)*/)

  let lastSlide = slide
  let at = tableTop + ((authorsIndexLayout.margin.cy + (lineHeight * scale) + authorsIndexLayout.margin.cy) * header.length)
  let body: PptxGenJS.TableRow[] = []

  const addRow = (rowNo: number, kojinNo?: number, identifier?: string, sames?: string/*, approach?: string, confidenceScore?: number*/) => {
    const background = ((rowNo % 2) === 0) ? colors.even : colors.odd
    const identifierLines = identifier ? splitTextInRect(identifier,
      layout.baseFont.fontSize * scale,
      layout.baseFont.fontFace,
      (identifierWidth - (authorsIndexLayout.margin.cx + authorsIndexLayout.margin.cx)) * layout.inchPerDot
    ) || [] : []

    const sameLines = sames ? splitTextInRect(sames,
      layout.baseFont.fontSize * scale,
      layout.baseFont.fontFace,
      (identifierWidth - (authorsIndexLayout.margin.cx + authorsIndexLayout.margin.cx)) * layout.inchPerDot
    ) || [] : []
/*
    const approachLines = approach ? 
      splitTextInRect(approach.replace(/\n/g, ''),
        layout.baseFont.fontSize * scale,
        layout.baseFont.fontFace,
        (authorsIndexLayout.column.approach - (authorsIndexLayout.margin.cx + authorsIndexLayout.margin.cx)) * layout.inchPerDot
      ) || [] : []
*/
    
    const rowHeight =
      authorsIndexLayout.margin.cy + 
      (lineHeight * scale * Math.max(1, identifierLines.length + sameLines.length/*, approachLines.length*/)) +
      authorsIndexLayout.margin.cy

    if ((at + rowHeight) > bottom) {
      lastSlide.addTable(header.concat(body), {
        x: layout.margin, y: tableTop,
        colW: [
          authorsIndexLayout.column.number * scale,
          identifierWidth,
          /*authorsIndexLayout.column.approach * scale,
          authorsIndexLayout.column.confidenceScore * scale*/
        ],
        border: { pt: 1, color: colors.border }
      })
      continueText({ ...other, slide: lastSlide, top: at })

      lastSlide = pptx.addSlide({ masterName: "MASTER_SLIDE" })
      body = []

      authorsIndexHeader({ ...other, slide: lastSlide, title, pageNo: ++pageNo })
      at = tableTop + ((authorsIndexLayout.margin.cy + (lineHeight * scale) + authorsIndexLayout.margin.cy) * header.length)
    }
    body.push([{
      text: kojinNo !== undefined ? `${kojinNo + 1}` : '',
      options: {
        ...layout.cellOption,
        fontSize: (layout.cellOption.fontSize ?? 0) * scale,
        fill: { color: background },
        align: 'center'
      }
    }, sameLines.length > 0 ? {
      text: [{
        text: identifierLines.join('\n'),
        options: {
          ...layout.cellOption,
          fontSize: (layout.cellOption.fontSize ?? 0) * scale,
          breakLine: true
        }
      }, {
        text: '→ ' + sameLines.join('\n'),
        options: {
          ...layout.cellOption,
          fontSize: (layout.cellOption.fontSize ?? 0) * scale,
          color: 'ff0000',
          breakLine: true
        }
      }],
      options: {
        fill: { color: background }
      }
    } : {
      text: identifierLines.join('\n'),
      options: {
        ...layout.cellOption,
        fontSize: (layout.cellOption.fontSize ?? 0) * scale,
        breakLine: true,
        fill: { color: background }
      }
    }/*, {
      text: approachLines.join('\n'),
      options: {
        ...layout.cellOption,
        fontSize: (layout.cellOption.fontSize ?? 0) * scale,
        breakLine: true,
        fill: { color: background }
      }
    }, confidenceScore ? {
      text: [{
        ...layout.cellOption,
        text: "★".repeat(Math.max(0, Math.min(5, confidenceScore))),
        options: {
          fontSize: (layout.cellOption.fontSize ?? 0) * scale,
          breakLine: false,
          color: colors.star.active
        }
      }, {
        ...layout.cellOption,
        text: "★".repeat(Math.max(0, Math.min(5, 5 - confidenceScore))),
        options: {
          fontSize: (layout.cellOption.fontSize ?? 0) * scale,
          breakLine: false,
          color: colors.star.inActive
        }
      }],
      options: {
        fill: { color: background }
      }
    } : {
      text: '-',
      options: {
        ...layout.cellOption,
        fontSize: (layout.cellOption.fontSize ?? 0) * scale,
        breakLine: true,
        fill: { color: background }
      }
    }*/])
    at += rowHeight
  }
  let kojinNo = 0
  let rowNo = 0
  for(const kojin of kojinList) {
    // eslint-disable-next-line no-irregular-whitespace
    const ishiName = `${(kojin.isiName ?? kojin.isiNameKana ?? 'No name')} 先生`
    const organ = (kojin.organ && (kojin.organ?.length ?? 0) > 0) ? flatJoin(' ',
      kojin.organ[0].sisetuName,
      kojin.organ[0].bukaName, 
      (kojin.organ[0].positionRank ?? 0) < 7500 ? kojin.organ[0].yakusyokuName : null
    ) : undefined
    const identifier = (ishiName ?? '???') + (organ ? `（${organ}）` : '')

    const sameOrganKojinList = kojinList.flatMap((other, i) => {
      if (kojin.kojinCode && other.kojinCode === kojin.kojinCode) return []
      if (kojin.authorId && other.authorId === kojin.authorId) return []
      if (other.organ?.some((otherOrgan) => kojin.organ?.some((organ) => organ.sisetuCode === otherOrgan.sisetuCode) ?? false) ?? false) {
        const otherName = other.isiName ?? other.isiNameKana
        if (!otherName) return []
        const otherNames = otherName.split('　')
        if (otherNames.length === 0) return []
        return `${otherNames[0]}先生 (No.${i+1})`
      }
      return []
    })
    const sames = sameOrganKojinList.length > 0 ? (sameOrganKojinList.join(', ') + 'と同施設') : undefined

    addRow(rowNo++, kojinNo++, identifier, sames/*, undefined, undefined*/)
  }
  if (body.length > 0) {
    lastSlide.addTable(header.concat(body), {
      x: layout.margin, y: tableTop,
      colW: [
        authorsIndexLayout.column.number * scale,
        identifierWidth,
        /*authorsIndexLayout.column.approach * scale,
        authorsIndexLayout.column.confidenceScore * scale*/
      ],
      border: { pt: 1, color: colors.border }
    })
  }
  return {
    slide: lastSlide,
    bottom: at
  }
}
